"use strict";

var _interopRequireDefault = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createProject = createProject;
exports.projectDel = projectDel;
exports.projectEdit = projectEdit;
exports.projectInfo = projectInfo;
exports.projectList = projectList;
exports.projectNotice = projectNotice;
exports.projectTargetEdit = projectTargetEdit;
exports.projectTargetInfo = projectTargetInfo;
exports.projectUploadImg = projectUploadImg;

var _request = _interopRequireDefault(require("@/utils/request"));

// 创建项目
function createProject(data) {
  return (0, _request.default)({
    url: '/laya_air_pro/project/create',
    method: 'post',
    data: data
  });
} // 获取项目列表


function projectList(params) {
  return (0, _request.default)({
    url: '/laya_air_pro/project/list',
    method: 'get',
    params: params
  });
} // 获取项目信息


function projectInfo(params) {
  return (0, _request.default)({
    url: '/laya_air_pro/project/info',
    method: 'get',
    params: params
  });
} // 编辑项目信息


function projectEdit(data) {
  return (0, _request.default)({
    url: '/laya_air_pro/project/edit',
    method: 'post',
    data: data
  });
} // 删除项目


function projectDel(data) {
  return (0, _request.default)({
    url: '/laya_air_pro/project/del',
    method: 'post',
    data: data
  });
} // 修改通知开关


function projectNotice(data) {
  return (0, _request.default)({
    url: '/laya_air_pro/project/notice_switch',
    method: 'post',
    data: data
  });
} // 上传项目封面图


function projectUploadImg(data) {
  return (0, _request.default)({
    url: '/laya_air_pro/project/upload_img',
    method: 'post',
    data: data
  });
} // 获取项目指标推荐值


function projectTargetInfo(params) {
  return (0, _request.default)({
    url: '/laya_air_pro/project/target_info',
    method: 'get',
    params: params
  });
} // 修改项目指标推荐值


function projectTargetEdit(data) {
  return (0, _request.default)({
    url: '/laya_air_pro/project/target_edit',
    method: 'post',
    data: data
  });
}